import {
  CMD_ID_MOTION,
  NOD_HEAD,
  OPERA_FACE,
  SHAKE_HEAD,
  TURN_HEAD,
} from "@/common/cmd";
import { track } from "@/common/utils";
import React from "react";
import { ICallAdapter } from "../adapters/CallAdapter";

interface EmojiPanelProps {
  visible: boolean;
  adapter?: ICallAdapter;
  onClose: () => void;
}

const EmojiPanel: React.FC<EmojiPanelProps> = ({
  visible,
  adapter,
  onClose,
}) => {
  if (!visible) return null;

  const emojis = [
    {
      id: NOD_HEAD,
      src: require("@/assets/images/emoji/nod-head.mp4"),
      alt: "Nod Head",
      text: "是的",
    },
    {
      id: SHAKE_HEAD,
      src: require("@/assets/images/emoji/shake-head.mp4"),
      alt: "Shake Head",
      text: "不是",
    },
    {
      id: TURN_HEAD,
      src: require("@/assets/images/emoji/turn-head.mp4"),
      alt: "Turn Head",
      text: "让我想想",
    },
    {
      id: OPERA_FACE,
      src: require("@/assets/images/emoji/opera-face.mp4"),
      alt: "Opera Face",
      text: "表情变脸",
    },
  ];

  const sendMsg = async (cmd: number, message: string) => {
    track("motion", { cmd, message });
    console.log(`Sending command: ${cmd}, message: ${message}`);

    if (!adapter) return;

    try {
      // 发送表情消息
      await adapter.sendMessage(cmd, message); // 使用 cmdId 0 表示表情
    } catch (error) {
      console.error("Failed to send emoji:", error);
    }
  };

  const handleEmojiClick = (emojiId: string) => {
    sendMsg(CMD_ID_MOTION, emojiId);
    onClose();
  };

  return (
    <div className="absolute bottom-0 left-0 w-full bg-gray-100 rounded-t-lg flex flex-col items-end z-20">
      <div
        onClick={onClose}
        className=" text-gray-700 active:opacity-50 text-3xl w-12 h-12 text-center"
      >
        ×
      </div>
      <div className="w-full flex justify-around items-center pb-2.5  shadow-md box-border">
        {emojis.map((emoji) => (
          <div
            className="flex flex-col items-center gap-1 active:opacity-50"
            onClick={() => handleEmojiClick(emoji.id)}
          >
            <video
              key={emoji.id}
              autoPlay
              loop
              muted
              className="w-16 h-16 cursor-pointer hover:scale-110 transition-transform"
            >
              <source src={emoji.src} type="video/mp4" />
            </video>
            <div className="text-sm text-gray-700">{emoji.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmojiPanel;
